import { generateId } from 'core-components/helpers/generateId'
import { IGroup } from 'core-components/library/filter'
import { Logic } from 'core-components/types'

export const GROUP_PREFIX = 'group'
export const CONDITION_PREFIX = 'condition'
export const CHANGE_TROTTLE_TIMER = 500

export const DEFAULT_GROUP: IGroup = {
  logic: Logic.AND,
  filters: [],
  id: generateId(GROUP_PREFIX),
}
